module.exports = __webpack_public_path__ + "static/img/30009 (1).4c84e5b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (1).webp
// module id = knVt
// module chunks = 14